import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '~/constants';
import { useConnectivitySignals } from '~/providers/ConnectivitySignalsProvider';
import { createStore } from '~/store/createStore';
import { Provider } from '~/store/store-context';
import { reportToSentry } from '~/store/StoreProvider.utils';
import { useIoContext } from '../providers/IoContext';
export function StoreProvider(props) {
    const { children, mgmtHost, apiGatewayHost, authDomain, enableAppcues, appcuesAccountId, useAuthorizationHeader = false, googleIosClientId = '', initialState, sessionTimeoutMS, initStoreApi } = props;
    const navigate = useNavigate();
    const { getNow, cookies, logBIEventOld, logBIEvent, native, browser } = useIoContext();
    const connectivitySignals = useConnectivitySignals();
    const store = useMemo(()=>createStore({
            initialState: initialState || {},
            session: {
                mgmtHost,
                apiGatewayHost,
                authDomain,
                useAuthorizationHeader,
                googleIosClientId,
                sessionTimeoutMS,
                enableAppcues,
                appcuesAccountId
            },
            onLogout: ()=>navigate(routes.logout),
            onNoAccess: ()=>navigate(routes.noAccessPage),
            getNow,
            initStoreApi,
            getCookie: ()=>cookies.getCookie(),
            onCookieChange: ()=>cookies.trySignalAuthTokenChange(),
            onAuthTokenInResponse: (authToken)=>cookies.setAuthTokenForNative(authToken),
            onAuthTokenRevoked: ()=>cookies.clearAuthToken(),
            onBiometricStaleToken: ()=>{
                void native.biometric.invalidateOnStaleToken();
            },
            reportToSentry,
            onLogBI: logBIEventOld,
            browser,
            logBIEvent,
            connectivitySignals
        }), // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
    []);
    return /*#__PURE__*/ _jsx(Provider, {
        value: store,
        children: children
    });
}
